export default function assignDisplayName(func) {
  // eslint-disable-next-line no-param-reassign
  func.displayName = `TR:${func.name}`;
  return func;
}
